var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 150,
    viewBox: "0 0 168 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.6755 0.176301C107.621 -2.20326 127.644 19.9482 143.544 39.8441C159.009 59.1961 173.067 82.4545 166.221 105.97C159.626 128.625 135.373 141.195 112.028 148.103C92.9846 153.738 74.5837 145.702 56.0925 138.56C34.8573 130.359 6.40619 126.534 0.833499 105.156C-4.77747 83.6314 19.277 67.8057 33.0023 49.9824C47.8393 30.7154 56.8866 2.4498 81.6755 0.176301Z",
    fill: "url(#paint0_linear_82_314)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_82_314",
    x1: 84,
    y1: 0,
    x2: 84,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC6BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopVector);
export default __webpack_public_path__ + "static/media/Laptop_Vector.e590144488dd844d60d2fe1d525b3cb2.svg";
export { ForwardRef as ReactComponent };